import { render, staticRenderFns } from "./mis_articulos.vue?vue&type=template&id=5f83e610&scoped=true&"
import script from "./mis_articulos.vue?vue&type=script&lang=js&"
export * from "./mis_articulos.vue?vue&type=script&lang=js&"
import style0 from "./mis_articulos.vue?vue&type=style&index=0&id=5f83e610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83e610",
  null
  
)

export default component.exports